import React from "react";
import "./Notpay.css";
import {
  FaBed,
  FaCouch,
  FaUtensils,
  FaBath,
  FaLaptop,
  FaDumbbell,
  FaChair,
  FaDollarSign,
  FaRulerCombined,
  FaBuilding,
  FaHome,
  FaLayerGroup,
  FaCalendarAlt,
} from "react-icons/fa";

// ======== Images ========
import heroBg from "../Images/home2.jpeg";
import osloImg from "../Images/home1.jpeg";
import reykjavikImg from "../Images/home1.jpeg";
import milanImg from "../Images/home1.jpeg";
import newImg1 from "../Images/plan1.png";
import newImg2 from "../Images/home1.jpeg";
import newImg3 from "../Images/plan2.png";

// ======== Room Icons List ========
const rooms = [
  { icon: <FaBed />, name: "Bedroom" },
  { icon: <FaCouch />, name: "Living Room / Hall" },
  { icon: <FaUtensils />, name: "Kitchen" },
  { icon: <FaBath />, name: "Bathroom" },
  { icon: <FaLaptop />, name: "Study / Office" },
  { icon: <FaDumbbell />, name: "Home Gym" },
  { icon: <FaChair />, name: "Dining Room" },
];

function Notpay() {
  return (
    <div className="app">
      {/* ===== HERO SECTION ===== */}
      <section
        className="hero"
        style={{
          backgroundImage: `linear-gradient(white, rgba(0,0,0,0.5)), url(${heroBg})`,
        }}
      >
        <div className="hero-container">
          <div className="hero-content"></div>

          <div className="destinations">
            <div className="destination-card">
              <img src={osloImg} alt="Oslo, Norway" />
            </div>
            <div className="destination-card">
              <img src={reykjavikImg} alt="Reykjavik, Iceland" />
            </div>
            <div className="destination-card">
              <img src={milanImg} alt="Milan, Italy" />
            </div>
          </div>
        </div>
      </section>

      {/* ===== DESCRIPTION + DETAILS SECTION ===== */}
      <section className="creativity-section">
        {/* Left Description */}
        <div
          className="left-section"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "left",
            alignItems: "left",
            textAlign: "left",
          }}
        >
          <h1>Description</h1>
          <br />
          <p>
            Architecture is the art and science of designing and constructing
            buildings <br /> and other physical structures. It involves the
            thoughtful planning, <br /> organization, and arrangement of spaces,
            materials, and forms to create <br /> functional, safe, and
            aesthetically pleasing environments. At its core, <br />
            architecture is not just about constructing buildings, but about{" "}
            <br />
            shaping the way people experience and interact with spaces.
          </p>
        </div>

        {/* Right Details */}
        <div className="right-section">
          <div className="pays-layout">
            {/* === Choose Room Column === */}
            <div className="choose-room">
              <h3>Choose a Room</h3>
              <ul className="pays-list">
                {rooms.map((room, index) => (
                  <li key={index} className="pays-item">
                    <span className="icon">{room.icon}</span>
                    <span className="name">{room.name}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* === Details Column === */}
            <div className="details-column">
              <h3 className="section-title">Architecture Details</h3>

              <div className="detail-item">
                <FaBuilding className="detail-icon" />
                <span className="detail-label">Style:</span>
                <span className="detail-value">Modern</span>
              </div>
              <div className="detail-item">
                <FaLayerGroup className="detail-icon" />
                <span className="detail-label">Floors:</span>
                <span className="detail-value">3</span>
              </div>
              <div className="detail-item">
                <FaCalendarAlt className="detail-icon" />
                <span className="detail-label">Completion:</span>
                <span className="detail-value">12 months</span>
              </div>

              <h3 className="section-title">Price Details</h3>
              <div className="detail-item">
                <FaDollarSign className="detail-icon" />
                <span className="detail-label">Base Price:</span>
                <span className="detail-value">$250,000</span>
              </div>
              <div className="detail-item">
                <FaHome className="detail-icon" />
                <span className="detail-label">Premium:</span>
                <span className="detail-value">$50,000</span>
              </div>
              <div className="detail-item">
                <FaDollarSign className="detail-icon" />
                <span className="detail-label">Total:</span>
                <span className="detail-value">$300,000</span>
              </div>

              <h3 className="section-title">Square Feet</h3>
              <div className="detail-item">
                <FaRulerCombined className="detail-icon" />
                <span className="detail-label">Total Area:</span>
                <span className="detail-value">2,500 sq ft</span>
              </div>
              <div className="detail-item">
                <FaRulerCombined className="detail-icon" />
                <span className="detail-label">Living Area:</span>
                <span className="detail-value">1,800 sq ft</span>
              </div>
              <div className="detail-item">
                <FaRulerCombined className="detail-icon" />
                <span className="detail-label">Outdoor Area:</span>
                <span className="detail-value">700 sq ft</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== PLANS SECTION ===== */}
      <section className="new-image-section">
        <h2>Plans</h2>
        <div className="new-image-row">
          <div className="new-image-card">
            <img src={newImg1} alt="Plan 1" style={{ filter: "blur(5px)" }} />
          </div>
          <div className="new-image-card">
            <img src={newImg2} alt="Plan 2" />
          </div>
          <div className="new-image-card">
            <img src={newImg3} alt="Plan 3" style={{ filter: "blur(5px)" }} />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Notpay;
